import React from "react"

import Layout from "../components/Layout/layout"
import SiteComponent from "../components/Site/site"
import SEO from "../components/seo"

const Site = () => (
  <Layout>
    <SEO title="The US Navy Toxic Waste Site" />
    <SiteComponent />
  </Layout>
)

export default Site
